import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { NGXLogger } from 'ngx-logger';
import { Observable, Subscription } from 'rxjs';

import { Timesheet } from '../../models/Timesheet';
import { FetchTimesheetsForProject } from '../../timesheets/timesheets.actions';
import { TimesheetState } from '../../timesheets/timesheets.state';

@Component({
    selector: 'app-timesheets-list',
    templateUrl: './timesheets-list.component.html',
    styleUrls: ['./timesheets-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class TimesheetsListComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    @Select(TimesheetState.timesheetsForProject) timesheets$: Observable<Timesheet[]>;
    public timesheets: Timesheet[] = [];

    @Input() projectId: string;

    constructor(private logger: NGXLogger, private store: Store) {}

    ngOnInit(): void {
        this.fetchData();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    private fetchData() {
        this.logger.info('Fetching timesheets');
        this.store.dispatch(new FetchTimesheetsForProject(this.projectId));

        this.subscriptions.add(
            this.timesheets$.subscribe((timesheets) => {
                if (timesheets) {
                    this.timesheets = timesheets;
                }
            }),
        );
    }
}
